import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { DashBoardComponent } from './dashboard.component';
import { DashBoardRoutingModule } from './dashboard-routing.module';

@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    DashBoardRoutingModule,
  ],
  declarations: [
    DashBoardComponent
  ]
})
export class DashBoardModule { }
